import { StringMatchRule } from '@/util/string';

export enum PostSearchMatchRuleType {
  CONTENT = 'content',
  TRANSCRIPT = 'transcript',
}

export interface PostSearchMatchRule extends StringMatchRule {
  type: PostSearchMatchRuleType;
}
